<script setup>
import { useI18n } from "vue-i18n";
import { blocks } from "@Utils/project";
import _filter from "lodash/filter";
import { createCloneBlock } from "./utils";
import Draggable from "vuedraggable";
import { computed } from "vue";
import SidebarBlock from "./SidebarBlock.vue";
import Disclosure from "./Disclosure.vue";

const emit = defineEmits(["addBlock", "start", "end"]);

const { t: __ } = useI18n();

const filteredBlocks = computed(() => {
    return _filter(blocks, ["group", "image"]);
});
</script>

<template>
    <Disclosure :title="__('Images')">
        <Draggable
            :list="filteredBlocks"
            tag="div"
            :group="{ name: 'blocks', pull: 'clone', put: false }"
            :clone="createCloneBlock"
            :sort="false"
            @start="$emit('start')"
            @end="$emit('end')"
            class="grid gap-2 2xl:grid-cols-2">
            <template #item="{ element: block, index }">
                <SidebarBlock :block="block" @addBlock="$emit('addBlock', $event)" />
            </template>
        </Draggable>
    </Disclosure>
</template>
